import React from "react";
import "./App.css";
// import Promise from "./components/Promise";
import AsyncAwait from "./components/AsyncAwait";
import LatestLaunch from "./components/LatestLaunch";
import AllLaunches from "./components/AllLaunches";
import Navbar from "./components/Navbar";
import { HashRouter as Router, Switch, Route } from "react-router-dom";

function App() {
  return (
    <>
      <Router>
        <Navbar />

        <div className="App">
          <div className="wrapper">
            <Switch>
              {/* <Promise /> */}
              <Route exact path="/">
                <LatestLaunch />
                <AllLaunches />
              </Route>
              <Route exact path="/latest">
                <LatestLaunch />
              </Route>
              <Route exact path="/past">
                <AllLaunches />
              </Route>
            </Switch>
          </div>
        </div>
      </Router>
    </>
  );
}

export default App;
